import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../utils/api';

export const fetchFlaggedContentList = createAsyncThunk(
  'contentModeration/fetchFlaggedContentList',
  async ({ page = 1, pageSize = 10, status, type }) => {
    const params = { page, pageSize };
    if (status) params.status = status;
    if (type) params.type = type;
    const response = await api.get('/content-moderation/flagged-content', { params });
    return response.data.data;
  }
);

export const approveFlaggedContent = createAsyncThunk(
  'contentModeration/approveFlaggedContent',
  async ({ id, adminComment }) => {
    const response = await api.post(`/content-moderation/flagged-content/${id}/approve`, { adminComment });
    return response.data.data;
  }
);

export const removeFlaggedContent = createAsyncThunk(
  'contentModeration/removeFlaggedContent',
  async ({ id, adminComment }) => {
    const response = await api.post(`/content-moderation/flagged-content/${id}/remove`, { adminComment });
    return response.data.data;
  }
);

export const editFlaggedContent = createAsyncThunk(
  'contentModeration/editFlaggedContent',
  async ({ id, contentPreview, flaggedReason, imageUrl, adminComment }) => {
    const response = await api.post(`/content-moderation/flagged-content/${id}/edit`, {
      contentPreview,
      flaggedReason,
      imageUrl,
      adminComment,
    });
    return response.data.data;
  }
);

export const addAdminComment = createAsyncThunk(
  'contentModeration/addAdminComment',
  async ({ id, adminComment }) => {
    const response = await api.post(`/content-moderation/flagged-content/${id}/comment`, { adminComment });
    return response.data.data;
  }
);

const initialState = {
  flaggedContents: [],
  totalCount: 0,
  page: 1,
  pageSize: 10,
  status: 'idle',
  error: null,
};

const contentModerationSlice = createSlice({
  name: 'contentModeration',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFlaggedContentList.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchFlaggedContentList.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.flaggedContents = action.payload.flaggedContents;
        state.totalCount = action.payload.totalCount;
        state.page = action.payload.page;
        state.pageSize = action.payload.pageSize;
      })
      .addCase(fetchFlaggedContentList.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message ?? null;
      })
      .addCase(approveFlaggedContent.fulfilled, (state, action) => {
        const index = state.flaggedContents.findIndex((fc) => fc.id === action.payload.id);
        if (index !== -1) {
          state.flaggedContents[index] = action.payload;
        }
      })
      .addCase(removeFlaggedContent.fulfilled, (state, action) => {
        const index = state.flaggedContents.findIndex((fc) => fc.id === action.payload.id);
        if (index !== -1) {
          state.flaggedContents[index] = action.payload;
        }
      })
      .addCase(editFlaggedContent.fulfilled, (state, action) => {
        const index = state.flaggedContents.findIndex((fc) => fc.id === action.payload.id);
        if (index !== -1) {
          state.flaggedContents[index] = action.payload;
        }
      })
      .addCase(addAdminComment.fulfilled, (state, action) => {
        const index = state.flaggedContents.findIndex((fc) => fc.id === action.payload.id);
        if (index !== -1) {
          state.flaggedContents[index] = action.payload;
        }
      });
  },
});

export default contentModerationSlice.reducer;
